module.exports = __webpack_public_path__ + "img/conference7.12fa81d2.png";